<template>
  <nav class="bg-base-100 shadow-lg sticky top-0 z-[997]">
    <div class="container mx-auto px-4">
      <div class="flex items-center justify-between h-16">
        <!-- Logo and Brand -->
        <router-link to="/" class="flex items-center space-x-3 group">
          <img src="@/assets/images/logo.webp" alt="WithTheKids Logo" class="h-10 w-10" width="40" height="40" />
          <span class="font-display text-3xl font-bold text-primary group-hover:text-primary-light transition-colors">
            WithTheKids
          </span>
        </router-link>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8">
          <router-link 
            v-for="item in navItems" 
            :key="item.path"
            :to="item.path"
            class="font-display text-base-content/80 hover:text-primary transition-colors relative group"
          >
            {{ item.name }}
            <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"></span>
          </router-link>
        </div>

        <!-- Mobile Menu Button -->
        <button 
          @click="isOpen = !isOpen"
          class="md:hidden p-2 rounded-lg hover:bg-base-200 transition-colors"
        >
          <svg 
            class="w-6 h-6" 
            :class="{ 'hidden': isOpen, 'block': !isOpen }"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg 
            class="w-6 h-6" 
            :class="{ 'block': isOpen, 'hidden': !isOpen }"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Mobile Navigation -->
      <div 
        class="md:hidden"
        :class="{ 'block': isOpen, 'hidden': !isOpen }"
      >
        <div class="px-2 pt-2 pb-3 space-y-1">
          <router-link 
            v-for="item in navItems" 
            :key="item.path"
            :to="item.path"
            class="block px-3 py-2 rounded-lg font-display text-base-content/80 hover:text-primary hover:bg-base-200 transition-colors"
            @click="isOpen = false"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'

const isOpen = ref(false)

const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Search', path: '/search' },
  { name: 'Locations', path: '/locations' },
  { name: 'About', path: '/about' },
]
</script>

<style scoped>
.router-link-active {
  @apply text-primary;
}
</style> 